// extracted by mini-css-extract-plugin
export default {"tab":"TabForm_tab__Yw7OW","header":"TabForm_header__H1Err","infos":"TabForm_infos__yRCtg","input":"TabForm_input__BXlC3","rotate":"TabForm_rotate__1QbyE"};